// crossfade images
$(".jsImageSwawp").hover(function () {
    var value = $(this).attr('data-image');
    var $jsImage = $(".jsImage");

    // fade out the current image
    $jsImage.fadeOut(200, function () {

        // change the image source
        $jsImage.attr("src", value);
        
        // fade in the new image
        $jsImage.fadeIn(200);
    });
});
